import { sandboxData } from './shared/state';

export default {
  namespaced: true,
  modules: {
    sandboxData
  }
};
